'use strict';

var inherits = require('inherits')
  , XhrDriver = require('../driver/xhr')
  ;

function XHRCorsObject(method, url, payload, opts) {
  XhrDriver.call(this, method, url, payload, opts);
}

inherits(XHRCorsObject, XhrDriver);

XHRCorsObject.enabled = XhrDriver.enabled && XhrDriver.supportsCORS;

module.exports = XHRCorsObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/transport/sender/xhr-cors.js
 ** module id = 190
 ** module chunks = 9
 **/